import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Text, VStack } from '@chakra-ui/react';

import LoadingSpinner from '../../../../components/Spinner';
import { analyticsIds } from '../../../../constants/analyticsIds';
import {
  selectEmailRecipientInsureds,
  selectEmailsError,
  selectIsSending,
  selectIsSent, sendInsuredBulkEmail
} from '../../../../redux/modules/emails';
import { hideModal } from '../../../../redux/modules/modal';

const SendEmailsModal = () => {
  const dispatch = useDispatch();
  const error = useSelector(selectEmailsError);
  const isSending = useSelector(selectIsSending);
  const isSent = useSelector(selectIsSent);
  const { total } = useSelector(selectEmailRecipientInsureds).pageInfo;

  if (isSent) {
    return (
      <VStack pt={2} textAlign="center">
        <Text pb={2} textStyle="bodyXl">Success!</Text>
        <Text pb={4} textStyle="bodyLg">
          Redirecting...
        </Text>
      </VStack>
    );
  }

  if (isSending) {
    return (
      <VStack pt={2} textAlign="center">
        <Text pb={2} textStyle="bodyXl">Sending email...</Text>
        <LoadingSpinner isInline minHeight="100px" />
      </VStack>
    );
  }

  if (error) {
    return (
      <VStack pt={2} textAlign="center">
        <Text pb={2} textStyle="bodyXl">Whoops. There was an error.</Text>
        <Text pb={4} textStyle="bodyLg">
          {error.message}
        </Text>
      </VStack>
    );
  }

  return (
    <VStack pt={2} textAlign="center">
      <Text pb={2} textStyle="bodyXl">
        {`Are you sure you want to send to ${total}+ recipients?`}
      </Text>
      <Text pb={4} textStyle="bodyLg">
        A CSV containing any missing emails will be emailed to you upon sending.
      </Text>

      <Button
        isRound
        data-analytics-id={analyticsIds.emailEditorPage.sendEmailButton}
        dusk={analyticsIds.emailEditorPage.sendEmailButton}
        isLoading={isSending}
        loadingText=""
        size="lg"
        variant="gradientSuccess"
        width="180px"
        onClick={async () => await dispatch(sendInsuredBulkEmail())}
      >
        Send Email
      </Button>
      <Button
        isDisabled={isSending}
        variant="textGrey"
        onClick={() => dispatch(hideModal())}
      >
        Cancel
      </Button>
    </VStack>
  );
};

export default SendEmailsModal;
